import { Collection } from '../../models/Collection';
import { pBase } from './.catalog';
import { Operation } from '../../services/operations/index';
import { Controls } from '../../services/controls';

export class filter {
  constructor(
    filters?:
      | Collection<filterItem>
      | Collection<IfilterItem>
      | filterItem[]
      | IfilterItem[]
      | filterItem
      | IfilterItem
  ) {
    if (Controls.IsNullOrUndefined(filters)) {
      this.filters = undefined;
    } else if (Controls.IsCollection(filters) || Controls.IsArray(filters)) {
      this.addFilterItems(
        filters as Collection<filterItem> | Collection<IfilterItem> | filterItem[] | IfilterItem[]
      );
    } else {
      this.addFilterItem(filters as filterItem | IfilterItem);
    }
  }

  public filters: filterItem[] | undefined;
  public logic: string = 'and';

  public clone = (): filter => {
    if (this.filters) {
      const filters = this.filters.map((i) => i.clone() || Operation.Clone(i));
      return new filter(filters);
    } else {
      return new filter();
    }
  };

  public addFilterItem = (input: filterItem | IfilterItem): void => {
    if (!Controls.IsNullOrUndefined(input)) {
      const _input = input instanceof filterItem ? input : new filterItem(input);
      if (Controls.IsNullOrUndefined(this.filters)) {
        this.filters = [];
      }
      this.filters?.push(_input);
    }
  };

  public addFilterItems = (
    input: Collection<filterItem> | Collection<IfilterItem> | filterItem[] | IfilterItem[]
  ): void => {
    let items: filterItem[] | IfilterItem[] = [];
    if (Controls.IsCollection(input)) {
      items = (input as Collection<filterItem> | Collection<IfilterItem>).list();
    } else if (Controls.IsArray(input)) {
      items = input as filterItem[] | IfilterItem[];
    }
    if (items.length > 0) {
      items.forEach((i: filterItem | IfilterItem) => this.addFilterItem(i));
    }
  };
}

interface IfilterItem {
  field: string;
  op: string;
  value: string;
  filters?: Collection<filterItem>;
}

export class filterItem implements IfilterItem {
  constructor(options: filterItem | IfilterItem) {
    this.filters = options.filters;
    this.field = options.field;
    this.op = options.op;
    this.value = options.value;
  }

  public filters: Collection<filterItem> | undefined;
  public field: string;
  public op: string;
  public value: string;

  public clone = (): filterItem => {
    return new filterItem({
      filters: this.filters,
      field: this.field,
      op: this.op,
      value: this.value,
    });
  };
}

export class sort {
  constructor() { }

  public compare: object | undefined;
  public dir: string | undefined;
  public field: string | undefined;
}

interface IPList {
  take?: number;
  page?: number;
  pageSize?: number;
  skip?: number;
  filter?: filter;
  sort?: Collection<sort>;
}

export default class pList extends pBase implements IPList {
  constructor(options?: pList | IPList) {
    super();
    this.take = options?.take;
    this.page = options?.page;
    this.pageSize = options?.pageSize;
    this.skip = options?.skip;
    this.filter = options?.filter;
    this.sort = options?.sort;
  }

  public take: number | undefined;
  public page: number | undefined;
  public pageSize: number | undefined;
  public skip: number | undefined;
  public filter: filter | undefined;
  public sort: Collection<sort> | undefined;

  public clone = (): pList => {
    return new pList({
      take: this.take,
      page: this.page,
      pageSize: this.pageSize,
      skip: this.skip,
      filter: this.filter?.clone(),
      sort: Operation.Clone(this.sort),
    });
  };

  public getFilterCount = (): number => this.filter?.filters?.length || 0;

  public getFilterCountExcludeYil = (): number => this.filter?.filters?.filter(i => i.field !== 'yil')?.length || 0;

  public addFilter = (input: filterItem | IfilterItem) => {
    if (this.filter) {
      this.filter.addFilterItem(input);
    } else {
      this.filter = new filter(input);
    }
    return this;
  };
}
